import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const ACTIVITY_NAME = 'turntable_activity_ludo'

export enum PageTypeEnum {
  tasks,
  rank,
  bag,
}
export const STORAGE_TURN_KEY = 'turn'

// 背包列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90611208
export const knapsack_list = createAsyncThunk(
  'LudoTurntableSkin/knapsack_list',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'list' | 'tips'>>
    >(
      '/gamestore/common/knapsack_list',
      {
        ...store.getState().env.deviceinfo,
        activity_name: ACTIVITY_NAME,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 任务列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92448285
export const common_activity_detail = createAsyncThunk(
  'LudoTurntableSkin/common_activity_detail',
  async (arg, store: any) => {
    const resp = await http.post('/gamestore/common/common_activity_detail', {
      ...store.getState().env.deviceinfo,
      activity_name: ACTIVITY_NAME,
    })
    return resp.data.data
  }
)
// 使用皮肤 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612319
export const use_game_skin = createAsyncThunk(
  'LudoTurntableSkin_use_mall_game_skin',
  async (arg: {room_id: number; pid: number; type: typeEnum}, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/gamestore/common/use_mall_game_skin',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
        game_tag: 'ludo',
        from: ACTIVITY_NAME,
      }
    )
    return resp.data.data
  }
)

// 领取任务奖励 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92448499
export const common_activity_reward = createAsyncThunk(
  'LudoTurntableSkin/common_activity_reward',
  async (arg: {mission_id: number; room_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        err_msg: string
        common_activity?: {
          List?: Array<MissionActivityItemSt>
        }
        reward?: {
          img_url: string
          reward_cnt: number
          reward_msg: string
        }
      }>
    >('/gamestore/common/common_activity_reward', {
      ...store.getState().env.deviceinfo,
      activity_name: ACTIVITY_NAME,
      ...arg,
    })
    return resp.data.data
  }
)
// 活动任务去完成 http://wiki.xunlei.cn/pages/viewpage.action?pageId=91711615
export const game_mission_goto_complete = createAsyncThunk(
  'LudoTurntableSkin/game_mission_goto_complete',
  async (arg: {room_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        scheme: number
        err_msg: string
      }>
    >('/gamestore/common/game_mission_goto_complete', {
      ...store.getState().env.deviceinfo,
      ...arg,
      game_tag: 'ludo',
      from: ACTIVITY_NAME,
    })
    return resp.data.data
  }
)

// 排行榜 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92444983
export const getMyRank = createAsyncThunk(
  'LudoTurntableSkin/getMyRank',
  async (p: any, store: any) => {
    const resp = await http.post('/gamestore/common/turntable_rank', {
      ...store.getState().env.deviceinfo,
      game_tag: 'ludo',
    })
    return resp.data
  }
)

export enum stateEnum {
  noUse = 0,
  using,
  canUse,
  expired,
}
enum typeEnum {
  //  1骰子皮肤 2棋子皮肤
  dice = 1,
  chessman,
}
export interface game_skin_type {
  id: number
  icon: string
  title: string
  state: stateEnum
  tag: string
  expire_day: number
  type: typeEnum
  pid: number
}
export enum missionStatus {
  goDo = 0,
  received,
  canGet,
  expired,
}
export enum rewardEnum {
  silverCoin = 7,
  skin,
}
interface MissionActivityItemSt {
  mission_id: number
  reward: {
    img_url: string
    reward_cnt: number
    is_box: boolean
    reward_type?: rewardEnum
    reward_msg?: string
  }
  status: missionStatus
  desc: string
  target: number
  current: number
}
interface IRank {
  rank: number
  name: string
  image: string
  score: number
  mine?: boolean
  mid: number
}
interface InitialStateType {
  // 背包列表
  list?: Array<{game_skin?: game_skin_type}>
  tips?: string
  // 任务列表
  common_activity_detail?: {
    list?: Array<MissionActivityItemSt>
  }
  myRank: {
    err_msg: string
    my_rank_info: IRank
    button_state: 0 | 1 | 2
    rewards: Array<any>
  }
  activity_time?: string
}

const initialState: InitialStateType = {
  myRank: {
    err_msg: '',
    my_rank_info: {
      image: '',
      name: '',
      rank: 0,
      score: 0,
      mine: true,
      mid: 0,
    },
    button_state: 0,
    rewards: [],
  },
}

export const LudoTurntableSkinSlice = createSlice({
  name: 'LudoTurntableSkin',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(knapsack_list.fulfilled, (state, action) => {
        Object.assign(state, action.payload)
      })
      .addCase(common_activity_detail.fulfilled, (state, action) => {
        if (action.payload.common_activity_detail && !action.payload.err_msg) {
          Object.assign(state, action.payload)
        }
      })
    // 领奖后更新任务
    builder
      .addCase(common_activity_reward.fulfilled, (state, action) => {
        if (action.payload.common_activity && !action.payload.err_msg) {
          Object.assign(state, {
            common_activity_detail: action.payload.common_activity,
          })
        }
      })
      .addCase(getMyRank.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        Object.assign(state.myRank, data)
      })
  },
})
export default LudoTurntableSkinSlice.reducer
export const LudoTurntableSkinActions = LudoTurntableSkinSlice.actions
